module.exports = __webpack_public_path__ + "8ed0350502209c11645d4a04f0b0e816.MP3";